import React from 'react';
import AntdTabs from 'antd/lib/tabs';
import classnames from 'classnames';

const AntdTabPane = AntdTabs.TabPane;

/**
 * {@docCategory TabPane}
 */
export interface TabPaneProps {
   tab?: React.ReactNode | string;
   style?: React.CSSProperties;
   closable?: boolean;
   className?: string;
   disabled?: boolean;
   forceRender?: boolean;
}

export const TabPane = (props: React.PropsWithChildren<TabPaneProps>) => {
   const tabPaneClassName = classnames('uf-tab-pane', props.className);

   return (
      <AntdTabPane {...props} className={tabPaneClassName} animated={false}/>
   );
};
